import "./SearchInput.css";
import { CiSearch } from "react-icons/ci";
const SearchInput = ({
  onHandleInput,
  title = "",
  placeHolder = "search...",
  value = "",
}) => {
  // resultData este array debe siempre tener la siguiente estructura

  return (
    <div className="search-container flex-grow-2">
      <CiSearch className="searh-icon" />
      {title && <p>{title}</p>}
      <input
        className="search-input"
        type="text"
        placeholder={placeHolder}
        onChange={(e) => onHandleInput(e)}
        value={value}
      />
    </div>
  );
};

export default SearchInput;
